import { setActiveAction} from '@process-advisor/process-miner/processMiner/processMiner'
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {}

export const setAction_InfluenceAnalysis = ({ eventEmitter }: Props) => {
    setActiveAction('influence_analysis')
    eventEmitter.emit(Event.setActionBar_InfluenceAnalysis, { findingID: null, source: 'influence_analysis' });
    eventEmitter.emit(Event.setDiagramWidth, { findingID: null });
};
